<template>
  <div class="ma-0 pa-0">
    <router-view />
    <notifications group="main" />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
